import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

interface AboutSection {
  id: string;
  labelKey: string;
}

@Component({
  selector: 'app-about-v2',
  templateUrl: './about-v2.component.html',
  styleUrls: ['./about-v2.component.scss']
})
export class AboutV2Component implements OnInit, OnDestroy {
  readonly sections: AboutSection[] = [
    { id: 'releases', labelKey: 'aboutV2.tabs.releases' },
    { id: 'jems-about', labelKey: 'aboutV2.tabs.jemsAbout' },
    { id: 'sbc', labelKey: 'aboutV2.tabs.sbc' },
    { id: 'ufrgs', labelKey: 'aboutV2.tabs.ufrgs' },
    { id: 'customer-reports', labelKey: 'aboutV2.tabs.customerReports' }
  ];

  activeSectionId = this.sections[0].id;
  markdownSrc: string;

  private langSub: Subscription;

  constructor(public translate: TranslateService) {}

  ngOnInit(): void {
    this.updateSrc();
    this.langSub = this.translate.onLangChange.subscribe(() => this.updateSrc());
  }

  ngOnDestroy(): void {
    this.langSub?.unsubscribe();
  }

  selectSection(id: string): void {
    this.activeSectionId = id;
    this.updateSrc();
  }

  private get lang(): 'en' | 'pt-BR' {
    return this.translate.currentLang === 'pt-BR' ? 'pt-BR' : 'en';
  }

  private updateSrc(): void {
    this.markdownSrc = `assets/about/${this.lang}/${this.activeSectionId}.md`;
  }
}
